"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M28.8 10.613A10.573 10.573 0 0 0 17.986.3a11.309 11.309 0 0 0-2.168.21A11.033 11.033 0 0 0 7.2 10.69C7.2 16.148 12 19.044 12 24v2h12v-2c0-5 4.8-8.048 4.8-13.387zM12 28v2.367a1.5 1.5 0 0 0 .359.973l3.524 4.133a1.5 1.5 0 0 0 1.142.527h1.951a1.5 1.5 0 0 0 1.141-.527l3.524-4.133a1.5 1.5 0 0 0 .359-.973V28z" })
);

